export default __webpack_public_path__ + "static/media/arrow-top.74ec1bb0.svg";